"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Backdrop_1 = require("@material-ui/core/Backdrop");
var CircularProgress_1 = require("@material-ui/core/CircularProgress");
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    backdrop: {
        zIndex: 1,
        color: '#fff',
    },
}); });
var LoadingBackdrop = function (props) {
    var classes = useStyles();
    return (React.createElement(Backdrop_1.default, { className: classes.backdrop, open: props.open },
        React.createElement(CircularProgress_1.default, { color: "inherit" })));
};
exports.default = LoadingBackdrop;
//# sourceMappingURL=LoadingBackdrop.js.map